// @ts-nocheck
import { Box, Container, Divider, Typography } from '@mui/material';
import { useApiVersion } from '../../api/version';

// First 7 chars of a commit SHA; passes 'dev' (local builds) through as-is.
const short = (sha?: string) => (sha ? sha.slice(0, 7) : null);

export default function DashboardFooter() {
  const year = new Date().getFullYear();
  const { data: apiVersion } = useApiVersion();

  const uiSha = short(__GIT_SHA__);
  const apiSha = short(apiVersion?.commit);

  return (
    <Box component="footer" sx={{ mt: 4 }}>
      <Divider />
      <Container maxWidth={false}>
        <Typography
          variant="body2"
          align="center"
          sx={{ color: 'text.secondary', py: 2 }}
        >
          &copy; {year}{' '}
          <Typography component="span" variant="body2" sx={{ color: 'primary.main', fontWeight: 600 }}>
            weSafe
          </Typography>
          . All rights reserved.
          <Typography
            component="span"
            variant="caption"
            sx={{ color: 'text.disabled', display: 'block', mt: 0.5 }}
          >
            ui {uiSha}
            {apiSha ? ` · api ${apiSha}` : ''}
          </Typography>
        </Typography>
      </Container>
    </Box>
  );
}
